import React from 'react';
import { twMerge } from 'tailwind-merge';
import { PreloadImage } from '~/components/preload-image';

interface ArrowButtonProps {
  direction: 'left' | 'right';
  onClick: () => void;
  show: boolean;
  styles: any;
  uiComponentId: string;
}

export function ArrowButton({
  direction,
  onClick,
  show,
  styles,
  uiComponentId,
}: ArrowButtonProps) {
  const isLeft = direction === 'left';
  const arrowId = `tab-arrow-${direction}-${uiComponentId}`;

  // Get arrow assets from styles
  const leftArrowAsset = styles?.tab_bar_left_arrow_asset;
  const rightArrowAsset = styles?.tab_bar_right_arrow_asset;

  return (
    <button
      onClick={onClick}
      className={twMerge(
        'group pointer-events-auto absolute z-10',
        'h-fit min-h-0 w-fit min-w-0',
        'tab-scroll-arrow',
        'hover:tab-scroll-arrow-hover',
        isLeft ? 'left-0' : 'right-0',
        !show && 'pointer-events-none opacity-0'
      )}
      aria-label={`Scroll tabs ${direction}`}
      aria-disabled={!show}
      data-testid={arrowId}
    >
      {/* Preload images for better performance */}
      {isLeft && leftArrowAsset && (
        <>
          <PreloadImage tailwindImageClass="tab-left-arrow-asset" />
          <PreloadImage tailwindImageClass="tab-left-arrow-asset-hover" />
        </>
      )}
      {!isLeft && rightArrowAsset && (
        <>
          <PreloadImage tailwindImageClass="tab-right-arrow-asset" />
          <PreloadImage tailwindImageClass="tab-right-arrow-asset-hover" />
        </>
      )}

      {/* Render custom assets if available, otherwise fallback to SVG */}
      {isLeft && leftArrowAsset ? (
        <div className="tab-left-arrow-asset bg-contain bg-center bg-no-repeat group-hover:tab-left-arrow-asset-hover" />
      ) : !isLeft && rightArrowAsset ? (
        <div className="tab-right-arrow-asset bg-contain bg-center bg-no-repeat group-hover:tab-right-arrow-asset-hover" />
      ) : (
        <svg
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          className="h-6 w-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d={isLeft ? 'M15 19l-7-7 7-7' : 'M9 5l7 7-7 7'}
          />
        </svg>
      )}
    </button>
  );
}
